import configureStore from './store'
import history from './utils/history'

export const store = configureStore({}, history)
